<template>
  <div>
    <div class="zn-template-head">
      <span class="zn-template-title">人选会面记录</span>
      <span class="zn-text-grey">根据手机号把内容解析到对应人选详情，并上传附件</span>
    </div>
    <div class="zn-template-content" ref="tplContent">
      <div
        v-loading="submiting"
        element-loading-text="努力解析中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <div class="zn-content-item-inline">
          <div class="zn-text-grey" style="width:65px;"><span style="color:#f00">*</span>手机：</div>
          <el-input size="mini" v-model="formData.手机" style="flex:1" @change="changePhone"></el-input>
          <div class="zn-text-grey" style="width:65px;margin-left:10px"><span style="color:#f00">*</span>姓名：</div>
          <el-input size="mini" v-model="formData.姓名" style="flex:1"></el-input>
        </div>
        <div class="zn-content-item-inline">
          <div class="zn-text-grey" style="width:65px">任职公司：</div>
          <el-input size="mini" v-model="formData.任职公司" style="flex:1"></el-input>
          <div class="zn-text-grey" style="width:65px;margin-left:10px">目前职位：</div>
          <el-input size="mini" v-model="formData.目前职位" style="flex:1"></el-input>
        </div>
        <div class="zn-content-item-inline">
          <div class="zn-text-grey" style="width:65px">见面时间：</div>
          <el-date-picker
            size="mini"
            v-model="formData.见面时间"
            type="date"
            value-format="yyyy.MM.dd"
            placeholder="选择日期"
            style="flex:1"
          >
          </el-date-picker>
          <div class="zn-text-grey" style="width:65px;margin-left:10px">见面目的：</div>
          <el-input size="mini" v-model="formData.见面目的" style="flex:1"></el-input>
        </div>
        <div class="zn-content-item" v-for="(fields, k) in fieldsObj" :key="k">
          <div class="zn-text-grey">{{ k }}：</div>
          <div style="padding-left:15px">
            <div class="zn-content-item" v-for="field in fields" :key="field.value">
              <div class="zn-text-grey">{{ field.label }}：</div>
              <el-input type="textarea" :rows="2" :placeholder="field.placeholder" v-model="formData[field.value]">
              </el-input>
            </div>
          </div>
          <template v-if="k == '对该人选评估'">
            <div class="zn-text-grey">口碑打分（1-5分）：</div>
            <div class="zn-score" style="padding-left:15px">
              <div v-for="(type, field) in scoretype" :key="field" class="zn-score-item">
                <span class="zn-text-grey" style="width:80px">{{ field }}：</span>
                <i class="el-icon-remove-outline" v-if="type == '+'" @click="changetype(field, '-')"></i>
                <i class="el-icon-circle-plus-outline" v-else-if="type == '-'" @click="changetype(field, '+')"></i>
                <el-rate
                  v-model="score[field]"
                  v-if="type == '+'"
                  void-icon-class="el-icon-star-on"
                  :icon-classes="['el-icon-star-on', 'el-icon-star-on', 'el-icon-star-on']"
                ></el-rate>
                <el-rate
                  v-model="score[field]"
                  v-else-if="type == '-'"
                  :colors="['#da3c3c', '#da3c3c', '#da3c3c']"
                  void-icon-class="el-icon-remove"
                  :icon-classes="['el-icon-remove', 'el-icon-remove', 'el-icon-remove']"
                ></el-rate>
              </div>
              <div class="zn-text-grey">候选人评价备注：</div>
              <div class="zn-content-item">
                <el-input type="textarea" :rows="3" placeholder="候选人评价备注" v-model="formData.候选人评价备注">
                </el-input>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div v-if="radishId" class="zn-template-submit" @click="openRadish(radishId)" style="margin-left:-110px;">
      查看人选详情
    </div>
    <div class="zn-template-submit" @click="submit" style="margin-left:10px;">完成填写</div>
  </div>
</template>
<script>
const dateFormat = require('dateformat')
import { phoneVali } from '../../../radish/src/constant/common-methods'
export default {
  props: {
    componentName: String,
  },
  data() {
    return {
      formData: {
        姓名: '',
        任职公司: '',
        目前职位: '',
        手机: '',
        见面目的: '',
        见面时间: '',
        沟通日志: '',
        业绩能力: '',
        对新工作的关注点: '',
        现在薪酬和期望薪酬: '',
        其他在谈的机会: '',
        考虑机会的原因: '',
        业绩: '',
        管理能力: '',
        专业高度: '',
        资源: '',
        口碑: '',
        情商: '',
        候选人评价备注: '',
        部门情况: '',
        团队做的好的人: '',
        他人评分: '',
        市场变动信息: '',
        BDleads: '',
        本行业推荐做的好的其他公司: '',
      },
      fieldsObj: {
        对该人选评估: [
          {
            label: '沟通日志',
            value: '沟通日志',
            placeholder: '形象、气质、表达（研究型/资源型/软性评价）',
          },
          {
            label: '业绩能力',
            value: '业绩能力',
            placeholder: '过往成绩产出数字',
          },
          {
            label: '对新工作的关注点',
            value: '对新工作的关注点',
            placeholder: '钱/老板/平台等',
          },
          {
            label: '现在薪酬和期望薪酬',
            value: '现在薪酬和期望薪酬',
            placeholder: '',
          },
          {
            label: '其他在谈的机会',
            value: '其他在谈的机会',
            placeholder: '进展阶段，是否拿到offer',
          },
          {
            label: '考虑机会的原因',
            value: '考虑机会的原因',
            placeholder: '内部推动力',
          },
        ],
        所在公司情况: [
          {
            label: '部门情况',
            value: '部门情况',
            placeholder: '团队划分、人员规模、业务方向等',
          },
          {
            label: '团队做的好的人',
            value: '团队做的好的人',
            placeholder: '谁、好在哪、为什么、意向度',
          },
          {
            label: '他人评分',
            value: '他人评分',
            placeholder: '使用系统list批量做口碑评分',
          },
        ],
        市场情况: [
          {
            label: '市场变动信息',
            value: '市场变动信息',
            placeholder: '自己公司，或者听说的他人的公司',
          },
          {
            label: 'BDleads',
            value: 'BDleads',
            placeholder: '市场还有哪些公司招人，汇报给谁',
          },
          {
            label: '本行业推荐做的好的其他公司',
            value: '本行业推荐做的好的其他公司',
            placeholder: '公司名、好的原因、灵魂人物',
          },
        ],
      },
      submiting: false,
      score: {},
      scoretype: { 业绩: '+', 管理能力: '+', 专业高度: '+', 资源: '+', 口碑: '+', 情商: '+' },
      radish: {},
      radishId: '',
      orgCompany: '',
      orgPosition: '',
      ceng: '',
    }
  },
  computed: {
    accounts() {
      return app.accounts
    },
  },
  watch: {
    formData: {
      // 缓存到local
      handler: function(newVal) {
        localStorage.setItem(this.componentName, JSON.stringify(newVal))
      },
      deep: true,
    },
  },
  methods: {
    changetype(type, val) {
      this.scoretype[type] = val
    },
    async duplicate() {
      const dup = await app.service('radish').duplicate({ phone: this.formData.手机 })
      if (dup.msg == 'duplicate') {
        this.radishId = dup.data.id
        return true
      } else {
        this.radishId = ''
        return false
      }
    },
    checkPhone() {
      if (this.formData.手机 && this.formData.手机.length > 0) {
        this.formData.手机 = this.formData.手机.replace(/[^0-9]/g, '').replace(/^86(.*?)/, '$1')
        if (!phoneVali(this.formData.手机)) {
          this.radishId = ''
          return false
        }
      } else {
        this.radishId = ''
        return false
      }
      return true
    },
    async changePhone() {
      if (!this.formData.手机) return
      if (!this.checkPhone()) return
      await this.duplicate()
      if (this.radishId) {
        const resR = await app.service('radish').simpleFetch({
          _id: this.radishId,
          fields: { 姓名: 1, 手机: 1, 公司: 1, 部门: 1, 目前职位: 1, 曾任职公司: 1 },
        })
        if (resR.status == 'success' && resR.data) {
          this.formData.姓名 = resR.data.姓名
          this.formData.任职公司 = resR.data.公司
          this.formData.目前职位 = resR.data.目前职位
          this.orgCompany = resR.data.公司
          this.orgPosition = resR.data.目前职位
          this.ceng = resR.data.曾任职公司
        } else {
          this.orgCompany = ''
          this.orgPosition = ''
          this.ceng = ''
        }
      }
    },
    async submit() {
      // return this.submiting = true
      try {
        if (this.submiting) return this.$message('正在解析中，请稍候')
        if (!this.formData.姓名) return this.$message('请填写姓名')
        if (!this.formData.手机) return this.$message('请填写手机')
        if (!this.checkPhone()) return this.$message('手机号格式错误')
        this.submiting = true
        // 根据手机获取人选
        await this.duplicate()
        if (!this.radishId) {
          // 新建人选
          const radishData = {
            姓名: this.formData.姓名,
            手机: this.formData.手机,
            公司: this.formData.任职公司,
            目前职位: this.formData.目前职位,
          }
          const radishRes = await app.service('radish').insert(radishData)
          if (radishRes.status === 'success') {
            this.radishId = radishRes.data.id
          } else {
            console.error(res.msg)
            return this.$message.error('新建人选失败')
          }
        } else {
          // 更新人选数据
          const option = {}
          if (this.formData.任职公司) {
            option.公司 = this.formData.任职公司
          }
          if (this.formData.目前职位) {
            option.目前职位 = this.formData.目前职位
          }
          if (this.orgCompany && this.orgCompany != this.formData.任职公司) {
            // 工作经历
            const item = { rid: this.radishId, type: '工作', 公司: this.orgCompany, 目前职位: this.orgPosition || '' }
            const eRes = await app.service('radish').addExperience(item)
            // item._id = eRes.data.ids[0]
            option.曾任职公司 = this.ceng ? this.orgCompany + ';' + this.ceng : this.orgCompany
          }
          if (Object.keys(option).length > 0) {
            await app.service('radish').modifyById({ _id: this.radishId, data: option })
          }
        }
        // 获取人选最新数据
        const resR = await app.service('radish').simpleFetch({
          _id: this.radishId,
          fields: { 姓名: 1, 手机: 1, 公司: 1, 部门: 1, 目前职位: 1 },
        })
        if (resR.status == 'success' && resR.data) {
          this.radish = resR.data
        } else {
          return this.$message.error('没有找到人选')
        }

        // 保存沟通备注
        let text = ''
        this.fieldsObj.对该人选评估.forEach(item => {
          if (this.formData[item.value]) {
            text += `${item.label}：${this.formData[item.value]}\n`
          }
        })
        if (text) {
          text = '对该人选评估：\n' + text
          const answer = {
            remark: [
              {
                stem: '沟通记录',
                answer: text,
                time: Date.now(),
                user: app.user.提供者 || app.user.account,
              },
            ],
            radishId: this.radishId,
          }
          const res = await app.service('communication').upsert(answer)
          if (res == 'success') {
            app.service('radish').addKpi({
              type: '电话',
              content: { rid: this.radishId },
            })
          }
        }

        // 保存口碑
        const score = JSON.parse(JSON.stringify(this.score))
        for (let key in this.type) {
          if (this.scoretype[key] == '-') {
            score[key] = -score[key]
          }
        }
        score.rid = this.radishId
        await app.service('company').insertRadishScore({ score, evaluate: this.formData.候选人评价备注 })

        // 保存部门情况
        if (this.formData.部门情况 && this.radish.公司 && this.radish.部门) {
          const departRes = await app
            .service('company')
            .getDepartmentDetail({ 公司: this.radish.公司, 部门: this.radish.部门 })
          if (departRes.status === 'success' && departRes.data) {
            const department = departRes.data || {}
            if (department._id) {
              await app.service('company').modifyDepartmentById({
                query: { _id: department._id },
                data: { 部门备注: (department.部门备注 ? department.部门备注 + '\n' : '') + this.formData.部门情况 },
              })
            }
          }
        }

        // 上传文件
        const t = this.formData.见面时间
          ? this.formData.见面时间.replaceAll(/\./g, '')
          : dateFormat(new Date(), 'yyyymmdd')
        const form = Object.assign({}, this.formData, score)
        const item = {
          fileName: `阿尔法-人选会面记录-${this.formData.公司名称 || ''}-${t}.doc`,
          type: '人选会面记录',
          form,
        }
        const res = await app.service('file').generateAppointmentByType(item)
        if (res.status == 'success') {
          const file = res.data
          try {
            // 保存附件
            const option = {
              rid: this.radishId,
              fileId: file._id,
              md5: file.md5,
              type: '会面记录',
              originalname: file.originalname,
              src: file.src,
              uploader: file.uploader,
            }
            const insertRes = await app.service('radish').addAttachment(option)
            if (insertRes.status == 'success') {
              this.$emit('closeTpl', {
                msg: '小阿已为您解析并上传完毕',
                other: { msgType: 'new', rid: this.radishId, 姓名: this.radish.姓名 },
              })
            } else {
              this.$message.error(insertRes.msg)
            }
          } catch (e) {
            this.$message.error(e.message)
          }
        }
        localStorage.removeItem(this.componentName)
        this.submiting = false
      } catch (e) {
        console.error(e)
      }
    },
    openRadish(rid) {
      window.open(`${window.frontend}/#/radish-detail-blank/${rid}`)
    },
    async initData(defaultForm) {
      if (defaultForm) {
        this.formData = defaultForm
      } else {
        this.formData = {
          姓名: '',
          任职公司: '',
          目前职位: '',
          手机: '',
          见面目的: '',
          见面时间: '',
          沟通日志: '',
          业绩能力: '',
          对新工作的关注点: '',
          现在薪酬和期望薪酬: '',
          其他在谈的机会: '',
          考虑机会的原因: '',
          业绩: '',
          管理能力: '',
          专业高度: '',
          资源: '',
          口碑: '',
          情商: '',
          候选人评价备注: '',
          部门情况: '',
          团队做的好的人: '',
          他人评分: '',
          市场变动信息: '',
          BDleads: '',
          本行业推荐做的好的其他公司: '',
        }
      }
    },
  },
}
</script>
